module.exports = __webpack_public_path__ + "img/tit.1c30bab7.png";